import compose from '../../../utils/components/_compose';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';

import ResourceAction, { ResourceActionProps } from './ResourceAction';

const ComposedResourceAction: (<Data, Error = {}>(
  props: ResourceActionProps<Data, Error>
) => React.ReactElement<ResourceActionProps<Data, Error>>) & {
  displayName: string;
  defaultProps: typeof ResourceAction.defaultProps;
  publicProps: typeof ResourceAction.publicProps;
} = compose<any>(
  withUniqueId('resourceActionId'),
)(ResourceAction);

ComposedResourceAction.displayName = 'ResourceAction';

export * from './ResourceAction';

export default ComposedResourceAction;
